// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api: 'https://www.holatudi.com/api',//'http://127.0.0.1:8000/api',
  stripe: {
    testKey: 'pk_test_51SF0PPGhmyIb2LncvEJvfO5EvQGaIxvRGEFMEqf8XBjZvHrZfezcTguuwxYPR8PNUiHq0CbOTb0D35CmcLug4DsY00799ZxbXf',
  }  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
